// extracted by mini-css-extract-plugin
export default {"top_menu_bar":"CategoryNewsMenu_top_menu_bar__1SFW7","back_icon":"CategoryNewsMenu_back_icon__G4OGh","menu_buttons":"CategoryNewsMenu_menu_buttons__P6p85"};